import { render, staticRenderFns } from "./FormDispositivos.vue?vue&type=template&id=52af11e1"
import script from "./FormDispositivos.vue?vue&type=script&lang=js"
export * from "./FormDispositivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports